import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import CurrencyInput from "../../../../Input/CurrencyInput";
import { jsx as _jsx } from "react/jsx-runtime";
function CurrencyInputCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(CurrencyInput, _extends({}, props));
}
export default CurrencyInputCell;